import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import UserAvatar from '../../../../userAvatar';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    boxSizing: 'border-box',
    backgroundColor: primary.bluish9,
    borderRadius: 8,
    padding: spacing(2, 4),
    width: '100%',
  },
}));

const Member = ({ member, canAccessUserProfileCheck, onGoToUserProfile }) => {
  const classes = useStyles();

  const isUserAccessible = canAccessUserProfileCheck(member.id);

  const handleClick = useCallback(() => {
    if (isUserAccessible) {
      onGoToUserProfile(member.id);
    }
  }, [isUserAccessible, onGoToUserProfile, member.id]);

  return (
    <div className={classes.root}>
      <UserAvatar
        user={member}
        variant="subtitle1"
        caption
        clickableCaption={isUserAccessible}
        onClickHandler={handleClick}
      />
    </div>
  );
};

Member.propTypes = {
  member: PropTypes.object.isRequired,
  canAccessUserProfileCheck: PropTypes.func.isRequired,
  onGoToUserProfile: PropTypes.func.isRequired,
};

export default memo(Member);
